import { Radius } from '../../../radius/converters/index.js';
import { isTouch } from '../../isTouch/isTouch/index.js';
import { ScrollbarSkins } from '../types/index.js';
import { ScrollbarSkinValues } from '../skins/index.js';

const scrollbar = ({ skin = ScrollbarSkins.Accent, width = 4, height, scrollbarProps, trackProps, thumbProps, } = {}) => {
    const tempSkin = ScrollbarSkinValues[skin];
    return !isTouch() ? ({
        '@supports (-moz-appearance:none)': {
            '&': {
                scrollbarColor: `${tempSkin.thumbBackgroundColor} ${tempSkin.trackBackgroundColor}`,
                scrollbarWidth: 'thin',
            },
        },
        '&::-webkit-scrollbar': {
            width,
            height,
            ...scrollbarProps,
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: Radius.r4,
            backgroundColor: tempSkin.trackBackgroundColor,
            ...trackProps,
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: Radius.r4,
            backgroundColor: tempSkin.thumbBackgroundColor,
            ...thumbProps,
        },
        '&::-webkit-scrollbar-corner': {
            background: 'transparent',
        },
    }) : null;
};

export { scrollbar };
